import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon,Card, CardBlock
} from 'reactstrap';
import Select from 'react-select';

import ReactTable from "react-table";
import "react-table/react-table.css";

import Spinner from 'react-spinkit';
import swal from 'sweetalert2';
import moment from 'moment';

import * as actions from '../../actions/cliente';

import IconSave from 'react-icons/lib/md/save';


import {api, request, API_URL,api_descarga} from '../../actions/_request';



const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);

const rangos = [
    {label: '1 mes', value: 1},
    {label: '2 meses', value: 2},
    {label: '3 meses', value: 3},
    {label: '4 meses', value: 4},
    {label: '5 meses', value: 5},
    {label: '6 meses', value: 6},
    {label: '7 meses', value: 7},
    {label: '8 meses', value: 8},
    {label: '9 meses', value: 9},
    {label: '10 meses', value: 10},
    {label: '11 meses', value: 11},
    {label: '12 meses', value: 12},
];
const tipos_clientes = [
    {label: 'Contado ( Sin P.G.)', value: 0},
    {label: 'Credito ( Sin P.G.)', value: 1},
    {label: 'Todos( Sin P.G.)', value: 3},
    {label: 'Publico General.', value: 4},

];
const tipo_documento = [
    {label: 'PDF', value: 1},
    {label: 'Excel', value: 2},

];

const categorias = [
    {label: 'Todos', value: 0},
    {label: 'Servicios', value: 10},

];



class KardexProveedor extends React.Component{
	constructor(props) {

        super(props);

        this.state = {
           	fecha_inicio : '2000-01-01',
           	fecha_fin 	 : moment().add(1, 'days').format('Y-MM-DD'),
            filtro : 3,
            rango1:1,
            rango2:1,
            tipo_cliente:0,
            tipo_documento:2,
            filtro_vencidas:0,
            filtro_documento:0,
            categoria_id:0,
        };
        
        this.buscar = this.buscar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this); 
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleSelectChange2 = this.handleSelectChange2.bind(this);
        this.correo = this.correo.bind(this);
    }

    handleInputChange(event) {
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
     
        this.setState({
            [name] : value
        });
    }

    handleSelectChange(select, name) {

        const value = select === null ? null : select.target.value;
        const nameSelect = select.target.name;

        this.setState({[nameSelect] : value});

    }
    handleSelectChange2(select, name) {

        
        const value = select === null ? null : select.value;
        console.log('value---->',value)
        this.setState({
            
                [name]: value
            
        });
    }

    buscar(evt){
    	evt.preventDefault();

    	let {fecha_inicio , fecha_fin , filtro,tipo_cliente,rango1,rango2,tipo_documento,filtro_vencidas,filtro_documento,categoria_id} = this.state;
    	let { proveedor , consulta} = this.props;
      let bandera=true;
      if(consulta == 6&& rango2>=rango1){
        swal("Oops..", "El Historial de compra tiene que ser mayor al periodo de no compra");
        bandera=false;
      }
      if(bandera){
         if(consulta == 1)
           window.open(`${API_URL}/consultaKardexCliente/${proveedor}/${fecha_inicio}/${fecha_fin}`);
          else if(consulta == 2)
            window.open(`${API_URL}/consultaFacturaAbonoscliente?proveedor=${proveedor}&fecha1=${fecha_inicio}&fecha2=${fecha_fin}&filtro=${filtro}`);
          else if(consulta == 3)
            window.open(`${API_URL}/cliente/productosComprados/${proveedor}/${fecha_inicio}/${fecha_fin}`);
          else if(consulta == 6){

            if(tipo_documento==1){
            window.open(`${API_URL}/reporte_clientes_no_compras/${tipo_cliente}/${fecha_fin}/${rango1}/${rango2}/${tipo_documento}/${categoria_id}`);
            }else{
              api_descarga().get(`/reporte_clientes_no_compras_excel/${tipo_cliente}/${fecha_fin}/${rango1}/${rango2}/${tipo_documento}/${categoria_id}`, []).then(function(response) {

                if(response.status === 200) {
                  // var a = document.createElement("a");
                  // a.href = response.data.file; 
                  // a.download = response.data.name;
                  // document.body.appendChild(a);
                  // a.click();
                  // a.remove();

                       const url = window.URL.createObjectURL(new Blob([response.data]));
                       const link = document.createElement('a');
                       link.href = url;
                       link.setAttribute('download', `Seguimiento de Clientes.xlsx`); //or any other extension
                       document.body.appendChild(link);
                       link.click();
                }
                else{
                }

              })
              .catch(function(error) {
               
              });

            }
          }else{
            if(consulta == 5)
               window.open(`${API_URL}/clientes/cuentas_vencidas/${filtro_vencidas}/${filtro_documento}`)
          }


      }
     
    }

    correo(evt){
      evt.preventDefault();

      let {fecha_inicio , fecha_fin , filtro,tipo_cliente,rango1,rango2} = this.state;
      let { proveedor , consulta} = this.props;
      let ruta ='';
      let self = this;

      // if(consulta == 1)
      //  window.open(`${API_URL}/consultaKardexCliente/${proveedor}/${fecha_inicio}/${fecha_fin}`);
      // else 
        if(consulta == 2)
        ruta=`/consultaFacturaAbonoscliente?proveedor=${proveedor}&fecha1=${fecha_inicio}&fecha2=${fecha_fin}&filtro=${filtro}&correo=1`;
      // else if(consulta == 3)
      //   window.open(`${API_URL}/cliente/productosComprados/${proveedor}/${fecha_inicio}/${fecha_fin}`);
      // else if(consulta == 6)
      //   window.open(`${API_URL}/reporte_clientes_no_compras/${tipo_cliente}/${fecha_inicio}/${rango1}/${rango2}`);
   
      if(ruta!=""){
        this.props.submitLoad(true);
        api().get(ruta)
          .then(function(response)
          {
            if(response.status === 200)
            {     self.props.submitLoad(false);
                  self.props.alerta({
                      mensaje:"Se Envio Correctamente el Documento",
                      tipo:"success",
                      creacion:moment().format('Y-MM-DD H:m:s'),
                    });        
            }
          });


      }
        
      }
    

    render(){
    	let {fecha_inicio , fecha_fin ,filtro} = this.state;
       let { proveedor , consulta} = this.props;
    	return(
    		<Modal isOpen={this.props.open} toggle={this.props.toggle} className="default modal-lg modal_cliente">
                <form >
                <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
                <ModalBody>
                	<div className="row">
                  {(this.props.consulta!=6&&this.props.consulta!=5)&&
                		<div className="col-4">
                			<div className="form-group">
                   				<label>inicio:</label>
                   				<Input
                   					placeholder=""
                   					type="date"
                   					name="fecha_inicio"
                   					value={fecha_inicio}
                   					onChange={this.handleInputChange}
                   				/>
                   			</div>
                		</div>
                   }
                   {(this.props.consulta!=5)&&
                    <div className="col-4">
                      <div className="form-group">
                          <label>{(this.props.consulta!=6)? 'Fin:':'Fecha'}</label>
                          <Input
                            placeholder=""
                            type="date"
                            name="fecha_fin"
                            value={fecha_fin}
                            onChange={this.handleInputChange}
                          />
                        </div>
                    </div>
                   }
                		
                    
                    {(this.props.consulta!=6&&this.props.consulta!=5)&&
                    <div className="col-4">
                      <label>Cliente:</label><br/>
                      <span className="mt-1">{this.props.nombreProveedor}</span>
                    </div>
                  }
                  {this.props.consulta==6&&
                  <div className="col-4"> 
                      <div className="form-group">
                          <label className>Tipo *:</label>
                          <Select
                              placeholder=""
                              type="text"
                              name="tipo_cliente"
                              options={tipos_clientes}
                              value={this.state.tipo_cliente }
                              onChange={ (select) => { this.handleSelectChange2(select, 'tipo_cliente') } }
                              clearable={false}

                          />
                      </div>
                  </div>
                }
                  {this.props.consulta==6&&
                  <div className="col-4"> 
                      <div className="form-group">
                          <label className>Historial de Compra de *:</label>
                          <Select
                              placeholder=""
                              type="text"
                              name="rango1"
                              options={rangos}
                              value={this.state.rango1 || ""}
                              onChange={ (select) => { this.handleSelectChange2(select, 'rango1') } }
                              clearable={false}

                          />
                      </div>
                  </div>
                }
                {this.props.consulta==6&&
                  <div className="col-4"> 
                      <div className="form-group">
                          <label className>Periodo de no compra mas de :*</label>
                          <Select
                              placeholder=""
                              type="text"
                              name="rango2"
                              options={rangos}
                              value={this.state.rango2 || ""}
                              onChange={ (select) => { this.handleSelectChange2(select, 'rango2') } }
                              clearable={false}

                          />
                      </div>
                  </div>
                }
                {this.props.consulta==6&&
                  <div className="col-4"> 
                      <div className="form-group">
                          <label className>Tipo Documento :*</label>
                          <Select
                              placeholder=""
                              type="text"
                              name="tipo_documento"
                              options={tipo_documento}
                              value={this.state.tipo_documento || ""}
                              onChange={ (select) => { this.handleSelectChange2(select, 'tipo_documento') } }
                              

                          />
                      </div>
                  </div>
                }
                {this.props.consulta==6&&
                  <div className="col-4"> 
                      <div className="form-group">
                          <label className>Categorias:</label>
                          <Select
                              placeholder=""
                              type="text"
                              name="categoria_id"
                              options={categorias}
                              value={this.state.categoria_id}
                              onChange={ (select) => { this.handleSelectChange2(select, 'categoria_id') } }
                              clearable={false}

                          />
                      </div>
                  </div>
                }
                	</div>
                  {this.props.consulta == 2?
                    <div className="row">
                      <div className="col-6">
                        <div className="form-group">
                          <label>Filtro:</label><br/>
                          <Input type="select" 
                            name="filtro" 
                            id="exampleSelect" 
                            value={filtro} 
                            onChange={(e) => this.handleSelectChange(e,'moneda')}
                           
                          >
                            <option value={'3'}>Todo</option>
                            <option value={'1'}>Saldo 0</option>
                            <option value={'2'}>Con Saldo</option>
                            <option value={'4'}>Remisones y Facturas Timbradas</option>
                            <option value={'5'}>Remisones y Facturas Vencidas</option>
                          </Input>
                          {/*</select>*/}
                        </div>
                      </div>
                    </div> : ''
                  }

                  {this.props.consulta == 5?
                    <div className="row">
                    <div className="col-6">
                        <div className="form-group">
                          <label>Filtro Vencidas:</label><br/>
                          <Input type="select" 
                            name="filtro_vencidas" 
                            id="exampleSelect" 
                            value={this.state.filtro_vencidas} 
                            onChange={(e) => this.handleSelectChange(e,'filtro_vencidas')}>
                            <option value={'0'}>Todas</option>
                            <option value={'7'}>7 Dias</option>
                            <option value={'14'}>14 Dias</option>
                            <option value={'21'}>21 Dias</option>
                            
                          </Input>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="form-group">
                          <label>Filtro Documento:</label><br/>
                          <Input type="select" 
                            name="filtro_documento" 
                            id="exampleSelect" 
                            value={this.state.filtro_documento} 
                            onChange={(e) => this.handleSelectChange(e,'filtro_documento')}>
                            <option value={'0'}>Todos</option>
                            <option value={'1'}>Facturas</option>
                            <option value={'2'}>Remisones</option>
                          </Input>
                        </div>
                      </div>
                      
                    </div> : ''
                  }

                </ModalBody>
                <ModalFooter>
                    {
                        this.props.cliente.saving ?
                        <SubmitLoad /> : 
                        <div>
                        {consulta==2&&
                             <Button color="primary" type="submit"  onClick={this.correo} >
                                Enviar Correo
                            </Button>
                            }{' '}
                            <Button color="primary" type="submit"  onClick={this.buscar} >
                                <IconSave />&nbsp;Buscar
                            </Button>{' '}
                            <Button color="secondary" onClick={this.props.toggle}>
                                Cancel
                            </Button>
                        </div>
                    }
                </ModalFooter>
                </form>
            </Modal>
    	);
    }
}

function mapStateToProps(state, ownProps) {
    return {
        cliente : state.cliente,
        auth:state.auth,
        notificciones:state.notificciones,
    }
};

export default connect(mapStateToProps, actions)(KardexProveedor)


// WEBPACK FOOTER //
// ./src/views/clientes/ModalKardexCliente.js